module.exports = __webpack_public_path__ + "static/media/g4r_logo.0a8adffb.svg";